import { useDispatch, useSelector } from 'react-redux';
import { Button, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { useToken } from '@app/hooks';
import { postProfileMessage, selectUser } from '@app/redux';
import { Issuer, selectConfig } from '@app/redux/config';
import { AuthEventTypes } from '@app/types';

import styles from './styles.module.scss';

const SignoutButton = (): JSX.Element => {
  const dispatch = useDispatch();

  const { t } = useTranslation('Profile');
  const { loading } = useSelector(selectUser);
  const { issuer } = useSelector(selectConfig);
  const { logout } = useToken();
  const isSalesforce = issuer === Issuer.Salesforce;

  const onClick = () => {
    dispatch(postProfileMessage({ eventType: AuthEventTypes.Logout }));
    logout();
  };

  return (
    <Button
      variant="secondary"
      theme="light"
      buttonSize="medium"
      onClick={onClick}
      className={styles['signoutButton']}
      disabled={isSalesforce || loading}
    >
      <Txt variant="labelMedium">{t('signout')}</Txt>
    </Button>
  );
};

export default SignoutButton;
